import React from "react";
import { computed } from "mobx";
import { inject } from "mobx-react";
import { Formik, FormikProps } from "formik";
import { Grid, Tooltip } from "@material-ui/core";
import { STPositionsTypography, STForm, CSButtonWrapper, STTypography, CSFab, STLocationGrid, STRemoveGrid, STGrid } from "./styles";
import { Values } from "@src/Tools/Values";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import { Location } from "@src/Interfaces/Entity/Location";
import { Position } from "@src/Interfaces/Entity/Position";
import { IManagementStore } from "@src/Stores/Management/types";
import { IValuesStore, IStringDict } from "@src/Stores/Values/types";
import DeleteIcon from "@material-ui/icons/Delete";
import _ from "lodash";
import FormSimpleSelect from "@src/Components/Common/FormFields/FormSimpleSelect/FormSimpleSelect";
import {IAuthStore} from "Stores/Auth/types";

export interface IPositionEdit {
  positions: IStringDict[];
}

interface IProps {
  positions: IStringDict[];
  onClose: () => void;
  onSubmit: (values: IPositionEdit) => Promise<void>;
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
}

@inject("values", "management", "auth")
export default class EditPositionForm extends React.Component<IProps> {  
  
  @computed get adminPositionId() {
    return this.props.values.common["AdminPositionId"];
  }
  
  @computed get locations(): Location[] {
    let items = _(this.props.management.activeLocations)
      .orderBy(x => x.name)
      .value();
    return items;
  }

  getPositions = (location: Location): Position[] => {
    let items = _(location.locationPositions)
      .uniq()
      .filter(position => _.some(this.props.management.activePositions, p => p.id == position.positionId))
      .map(position => _.find(this.props.management.activePositions, p => p.id == position.positionId))
      .orderBy(x => x.name)
      .value();
    items.forEach((item) => {
      if (item.id == this.adminPositionId && !this.props.auth.isAdmin) {
        item.isDisabledAdminPosition = true;
      }
    })
    return items;
  }

  getFieldName = (location: Location): string => {
    return `positions.${[location.id]}`
  }

  handleRemove = (location: Location, formikProps: FormikProps<IPositionEdit>) => {
    const newPositions = { ...formikProps.values.positions } as any;
    delete newPositions[location.id];
    formikProps.setFieldValue("positions", newPositions);
  }

  handleLocationChange = (location: Location, item: any, formikProps: FormikProps<IPositionEdit>) => {
    const newPositions = { ...formikProps.values.positions as any };
    newPositions[location.id] = item;
    formikProps.setFieldValue(`positions`, newPositions);
  }
  
  disableInputWithAdminSelected = (locationId: string) => {
    return this.props.positions[locationId] == this.adminPositionId && !this.props.auth.isAdmin;
  }

  render() {
    console.log(this.props.positions);
    return (
      <Formik
        initialValues={{ positions: this.props.positions }}
        onSubmit={this.props.onSubmit}
        render={(formikProps: FormikProps<IPositionEdit>) => (
          <STForm onSubmit={formikProps.handleSubmit}>
            <Grid container direction="column">
              <Grid item>
                <STPositionsTypography>
                  {Values.getLocalizationValue("positions")}
                </STPositionsTypography>
              </Grid>
              <STGrid item xs={12}>
                {this.locations.map((location, index) => {
                  const dropdownPositions = this.getPositions(location);
                  const fieldName = this.getFieldName(location);
                  return (
                    <Grid container alignItems="flex-end" key={index}>
                      <STLocationGrid item xs={3}>
                        <STTypography>{location.name}</STTypography>
                      </STLocationGrid>
                      <Grid item xs={7}>
                        <FormSimpleSelect<IPositionEdit, Position> 
                          fieldName={fieldName}
                          formikProps={formikProps}
                          items={dropdownPositions}
                          keyAsTitle="name"
                          keyAsValue="id"
                          keyAsOptionDisabled={"isDisabledAdminPosition"}
                          keyAsDescription="description"
                          label={Values.getLocalizationValue("position")}
                          onChange={(item: any) => this.handleLocationChange(location, item, formikProps)}
                          optionalField={true}
                          disabled={this.disableInputWithAdminSelected(location.id)}
                        />
                      </Grid>
                      <STRemoveGrid item xs={2}>
                        <Tooltip
                          title={Values.getLocalizationValue("remove")}
                          placement="top">
                          <CSFab
                              color="secondary"
                              size="small"
                              onClick={() => this.handleRemove(location, formikProps)}
                              disabled={this.disableInputWithAdminSelected(location.id)}
                          >
                            <DeleteIcon />
                          </CSFab>
                        </Tooltip>
                      </STRemoveGrid>
                    </Grid>
                  )})
                }                    
              </STGrid>
              <Grid container justify="center">
                <CSButtonWrapper>
                    <STButtonMargin
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      <DoneIcon />
                    </STButtonMargin>
                    <STButtonMargin
                      onClick={this.props.onClose}
                      variant="contained"
                    >
                      <ClearIcon />
                    </STButtonMargin>
                </CSButtonWrapper>
              </Grid>
            </Grid>
          </STForm>
        )}
      />
    );
  }
}
